<template>
  <BillingCoupon
    v-if="billing.showDiscountBanner"
    :billing="billing"
    class="billing-data__coupon billing-notifications__prompt"
  />
  <BillingNotifications class="billing-data__notification" :billing="billing" />
  <PlanCards :billing="billing" />
  <Features />
  <UserReview />
  <Benefits class="billing-data__benefits" />
  <Bestselling />
  <PlanCards :billing="billing" is-secondary />

  <InfoFAQ id="faq" class="billing-data__faq" />
</template>

<script setup lang="ts">
import { BillingView } from '@/models/billing'

import PlanCards from './PlanCards.vue'
import InfoFAQ from '@/app/components/billing/InfoFAQ.vue'
import BillingCoupon from '@/app/components/billing/BillingCoupon.vue'
import Benefits from './Benefits.vue'
import Features from './Features.vue'
import Bestselling from './Bestselling.vue'
import UserReview from './UserReview.vue'
import BillingNotifications from './BillingNotifications.vue'

defineProps<{
  billing: BillingView
}>()
</script>

<style scoped lang="scss">
.billing-data {
  &__faq {
    margin-top: 16px;
    margin-bottom: 0px;
    @media (max-width: $w-tablet-s) {
      :deep(.container) {
        padding-top: 24px;
      }
    }
  }

  &__benefits {
    gap: 40px;
    margin-bottom: 72px;
  }

  &__notification {
    max-width: 660px;
    padding-inline: var(--container-padding);
    margin-inline: auto;

    &:deep(.notification) {
      margin-bottom: 0;
    }

    :deep(.notification__title) {
      @media (max-width: $w-mobile-s) {
        font-size: 24px;
        line-height: 32px;
        font-weight: 500;
        margin-bottom: 14px;
      }
    }
  }

  &__coupon {
    margin-top: 48px;
    margin-bottom: 0;
  }
}

section {
  display: flex;
  flex-direction: column;
  margin-bottom: 72px;
}

:deep(.billing-data__title) {
  text-align: center;
  font-size: 36px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -0.02em;
  @media (max-width: $w-tablet-s) {
    font-size: 28px;
    line-height: 30px;
  }
  @media (max-width: $w-mobile-s) {
    font-size: 24px;
  }
}

.night-mode {
  .billing-data__faq {
    background: $c-bg-5;
  }
}
</style>
